import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormItem, FormLabel, FormInputSelect } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';

var _excluded = ["children"],
  _excluded2 = ["label", "feedback", "helper", "caption", "tooltip", "options", "multiple"];

/** @typedef {import('@tesla/react-context-form/types/hooks/useFormField').FormFieldProps} FormFieldProps */

/**
 * Renders a dropdown list
 *
 * @param {FormFieldProps} props
 */
function Select(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  // multiple={multiple}

  var _useField = useField(_objectSpread2({
      type: 'select'
    }, props)),
    informed = _useField.informed,
    fieldState = _useField.fieldState,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  var label = userProps.label,
    feedback = userProps.feedback,
    helper = userProps.helper,
    caption = userProps.caption,
    tooltip = userProps.tooltip,
    options = userProps.options,
    multiple = userProps.multiple,
    inputProps = _objectWithoutProperties(userProps, _excluded2);
  var disabled = inputProps.disabled,
    id = inputProps.id;
  var showError = fieldState.showError,
    error = fieldState.error,
    value = fieldState.value;
  var v = value || (multiple ? [] : '');
  return render( /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    variant: "select",
    disabled: disabled
  }, label ? /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: id,
    caption: caption,
    tooltip: tooltip
  }, label) : null, /*#__PURE__*/React.createElement(FormInputSelect, _extends({}, informed, inputProps, {
    multiple: multiple,
    value: v,
    id: id,
    inputRef: ref,
    disabled: disabled,
    options: options
  }), children), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError
  })));
}

export { Select };
